<template>
  <b-container class="p-3" style="box-sizing: border-box; height: 100vh;">
    <b-row align-h="center" align-v="center" class="mb-3">
      <b-col md="7" lg="5">
        <!-- <box>
          <form-header title="Recover password" />
          <hr />
          <b-form-group label="Email:" label-for="email">
            <b-form-input size="lg" id="email" type="text" required />
          </b-form-group>
          <b-button style="width: 100%;" variant="primary" class="mt-6">
            SEND EMAIL
          </b-button>
        </box> -->
        <div :is="componentName" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FormEmail from './components/ForgotEmail.vue';
import FormConfirm from './components/ForgotConfirm.vue';
import * as auth from '@/utils/auth.js';

export default {
  head: {
    title() {
      return {
        inner: this.$t('metaTitle.passwordRecovery')
      };
    }
  },

  components: {
    FormEmail,
    FormConfirm
  },

  computed: {
    componentName() {
      switch (this.$route.name) {
        case 'forgot':
          return 'FormEmail';
        case 'confirm-reset':
          return 'FormConfirm';
        default:
          return '';
      }
    }
  },

  beforeCreate() {
    if (auth.readToken()) {
      this.$router.replace({
        name: 'dashboard'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  min-height: 100%;
}
.logo {
  border-bottom: none;
}
</style>
